import { addTransactionToCache } from 'actions';
import { PHYSICAL_ASSET_TYPES } from 'features/accounts/constants';
import { selectShowNewPhysicalAssets } from 'features/accounts/selectors';
import { useCallback } from 'react';
import { selectAccountById } from 'reducers/selectors';
import { useAppDispatch, useAppSelector, useAppStore } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const useNavigateTransactionItem = () => {
    const navigation = useMainStackNavigation();
    const dispatch = useAppDispatch();
    const store = useAppStore();
    const showNewPhysicalAssets = useAppSelector(selectShowNewPhysicalAssets);
    const navigateToTransactionItem = useCallback((item, isCompact, additionalParams) => {
        const transaction = {
            ...item,
            ...(isCompact ? { isCompact: true } : {}),
        };
        dispatch(addTransactionToCache(transaction));
        const account = selectAccountById(store.getState(), item.accountId);
        if (item.accountType &&
            PHYSICAL_ASSET_TYPES.has(item.accountType) &&
            account?.isManual &&
            showNewPhysicalAssets) {
            navigation.navigateDeprecated('EditValuationChange', {
                transactionId: item.id,
                accountId: item.accountId,
                accountType: item.accountType,
            });
        }
        else {
            navigation.navigateDeprecated('Item', {
                id: item.id,
                ...additionalParams,
            });
        }
    }, [showNewPhysicalAssets, store]);
    return navigateToTransactionItem;
};
export default useNavigateTransactionItem;
